import { Button, styled } from "@mui/material";
import IconButton from '@mui/material/IconButton';

export const NavbarPrimaryButton = styled(Button)({
    cursor: "pointer",
    borderRadius: 0,
    display: "flex",
    alignItems: "center",
    color: "#FFF",
    fontSize: "16px",
    // height: "100%",
    textTransform: "capitalize",
    // backgroundColor: "#006EFF",
    minWidth: "152px",
    "&:disabled": {
        opacity: 0.5,
        color: "#FFF"
    },
    "&:after": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "#006EFF",
        transition: "all .3s",
        zIndex: -2,
        // top: "50%", // Move the center of the circle to the middle
        // left: "50%", // Move the center of the circle to the middle
        // width: "100%", // Set the width and height larger than the button size
        // height: "100%", // Set the width and height larger than the button size
        // transform: "translate(-50%, -50%)",

    },
    "&:before": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "0%",
        height: "100%",
        backgroundColor: "#004FB8",
        transition: "all .3s",
        zIndex: -1,
        // top: "50%", // Move the center of the circle to the middle
        // left: "50%", // Move the center of the circle to the middle
        // width: "0%", // Start with 0% width
        // height: "0%", // Start with 0% height
        // transform: "translate(-50%, -50%)"
    },
    "&:hover": {
        color: "#FFF",
        "&:before": {
            width: "100%",
        }
    }
})

export const NavbarHamburgerMenuButton = styled(IconButton)({
    cursor: "pointer",
    borderRadius: 9999,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#FFF",
    backgroundColor: "#006EFF",
    "&:hover": {
        color: "#FFF",
        background: "#006EFF",
    },
})

export const PrimaryButton = styled(Button)({
    opacity: 1,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    color: "#FFF",
    // height: "100%",
    textTransform: "none",
    fontSize: "16px",
    fontWeight: "500 !important",
    borderRadius: "6px",
    transition: 'all .3s',
    position: "relative",
    overflow: "hidden",
    zIndex: 1,
    padding: "12px 16px",
    "&:disabled": {
        opacity: 0.5,
        color: "#FFF"
    },
    "&:after": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "100%",
        height: "100%",
        borderRadius: "6px",
        backgroundColor: "#006EFF",
        transition: "all .3s",
        zIndex: -2,
        // top: "50%", // Move the center of the circle to the middle
        // left: "50%", // Move the center of the circle to the middle
        // width: "100%", // Set the width and height larger than the button size
        // height: "100%", // Set the width and height larger than the button size
        // transform: "translate(-50%, -50%)",

    },
    "&:before": {
        content: '""',
        position: "absolute",
        bottom: 0,
        left: 0,
        width: "0%",
        height: "100%",
        borderRadius: "6px",
        backgroundColor: "#004FB8",
        transition: "all .3s",
        zIndex: -1,
        // top: "50%", // Move the center of the circle to the middle
        // left: "50%", // Move the center of the circle to the middle
        // width: "0%", // Start with 0% width
        // height: "0%", // Start with 0% height
        // transform: "translate(-50%, -50%)"
    },
    "&:hover": {
        color: "#FFF",
        "&:before": {
            width: "100%",
        }
    }
})